module.exports = __webpack_public_path__ + "static/hop-color-17ab076b47413ba095de07e197321b5f.svg";